<template>

    <a :href="href"
        class="block">

        <img class="w-full"
            :src="src"
            alt="Logo" />

    </a>

</template>

<script>
import { defineComponent } from 'vue'
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    components: {
        Link,
    },

    props: {

        href: {
            type: String,
            default: '/'
        },

        src: {
            type: String,
            default: '/images/logo.png'
        }
    }

});
</script>
